import { css } from 'styled-components'

export const Widget = css`
  color: ${({ theme }) => theme.color.strongText};
  margin: 0;
`
